import { render } from "./AssignForm.vue?vue&type=template&id=7cb1bcc4&scoped=true"
import script from "./AssignForm.vue?vue&type=script&lang=js"
export * from "./AssignForm.vue?vue&type=script&lang=js"

import "./AssignForm.vue?vue&type=style&index=0&id=7cb1bcc4&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb1bcc4"]])

export default __exports__